import LogRocket from 'logrocket';

if (window.location.hostname === 'ticket.laddition.com') {
  LogRocket.init('q2xmea/laddition-ticket');
}
